import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/expertDetails.css";
import expertDefaultImg from "../images/expert-default.png";
import AddToProject from "../components/ExpertDetails/AddToProject";
import ZohoButtons from "../components/ExpertDetails/ZohoButtons";
import UpdateExperience from "../components/ExpertDetails/UpdateExperience";
import UpdateProfile from "../components/ExpertDetails/UpdateProfile";
import MergeExpertsBtn from "../components/ExpertDetails/MergeExpertsBtn";
import UpdateProfileExperience from "../components/ExpertDetails/UpdateProfileExperience";
import DeleteExpert from "../components/ExpertDetails/DeleteExpert";
import Swal from "sweetalert2";
import { UrlContext } from "../contexts/UrlContext";
// import bannerBack from "../images/banner_background.png";
import bannerBack from "../images/eph_cms-banner.jpg";
import logoWhite from "../images/logo_white.png";
import Verified from "../components/EphProfile/Verified";
import Vip from "../components/EphProfile/Vip";
import CV from "../components/EphProfile/CV";
import ProfilePage from "../components/EphProfile/ProfilePage";
import ProjectsPage from "../components/EphProfile/ProjectsPage";
import InvitationsPage from "../components/EphProfile/InvitationsPage";
import MyProjectPage from "../components/EphProfile/MyProjectPage";
import ExpertAverageRating from "../components/EphProfile/ExpertAverageRating";
import { motion, AnimatePresence } from "framer-motion";
import { DateTime } from "luxon";
import ProfileCompletionChart from "../components/EphProfile/ProfileCompletionChart";
import industryLogo from "../images/default_industry.png";
import { useNavigate } from "react-router-dom";
import ProfilePicture from "../components/EphProfile/ProfilePicture";
// import { Update } from "@mui/icons-material";

export const UserContext = createContext();

export default function ExpertDetails() {
  useEffect(() => {
    document.title = "Expert Details";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const id = useParams().id;
  const [data, setData] = useState(null);
  const [count, setCount] = useState(0);
  const [verified, setVerified] = useState(false);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [experienceData, setExperienceData] = useState([]);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const [showMenuPanel, setShowMenuPanel] = useState(false);
  const [profilePicturePreview, setProfilePicturePreview] = useState("");
  const [editNameTooltip, setEditNameTooltip] = useState(false);
  const [profileName, setProfileName] = useState("");
  const [editedName, setEditedName] = useState("");
  const [linkedinURL, setLinkedinURL] = useState("");
  const [editedLinkedinURL, setEditedLinkedinURL] = useState("");
  const [isNameEditing, setIsNameEditing] = useState(false);
  const [showNameTooltip, setShowNameTooltip] = useState(false);
  const [nameTooltipTimer, setNameTooltipTimer] = useState(null);
  const tabs = [
    { label: "My Profile", state: "profile" },
    { label: "My Projects", state: "myProjects" },
    { label: "Invitations", state: "invitation" },
    { label: "Projects", state: "projects" },
  ];
  const [activeTab, setActiveTab] = useState("profile");
  const [newInvite, setNewInvite] = useState(null);
  const [averageRating, setAverageRating] = useState(null);

  // for profile completion pie chart
  const [hasCV, setHasCV] = useState(false);
  const [hasExperience, setHasExperince] = useState(false);
  const [hasSkill, setHasSkill] = useState(false);
  const [hasLanguage, setHasLanguage] = useState(false);
  const [hasIndustry, setHasIndustry] = useState(false);
  const navigate = useNavigate();
  const [onlineStatus, setOnlineStatus] = useState({});
  const [expert, setExpert] = useState(null);

  // Dynamic dot and highlighting 
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [randomHighlights, setRandomHighlights] = useState([[], [], []]);

  // Fetch expert data
  useEffect(() => {
    const fetchExpert = async () => {
      const tokenObj = localStorage.getItem("eph-token");
      const token =
        JSON.parse(tokenObj)?.value || localStorage.getItem("AccessToken");
      const url = `${API_URL}expert-details/${id}`;

      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();

        // Handle unauthorized, token expired, etc.
        const isAuthError =
          res.status === 401 ||
          res.status === 403 ||
          /unauthorized|token|expired/i.test(data.text || "");

        // Need to change the navigate in Consultant portal
        if (!res.ok || data.status === "error") {
          navigate("/error", {
            state: {
              errorMessage: data.text || "Authentication or server error",
              statusCode: res.status,
              retryPath: url,
              redirectAfterSuccess: `/app/ExpertDetails/${id}`,
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              isAuthError,
            },
          });
          return;
        }

        // Success
        fetchProjects();
        setData(data.expert);
        setExpert(data.expert);
        setProfileName(data.expert.name);
        setLinkedinURL(data.expert.link);
        setVerified(data.expert.verified);
        // setProfilePicturePreview(data.expert.profilePicture === null ? null : data.expert.profilePicture.includes(mediaLink) ? data.expert.profilePicture : `${databaseLink}${data.expert.profilePicture}`);
        const profilePic = data.expert.profilePicture;
        if (!profilePic) {
          setProfilePicturePreview(null);
        } else {
          const isFullURL = profilePic.includes(mediaLink);
          setProfilePicturePreview(
            isFullURL ? profilePic : `${databaseLink}${profilePic}`
          );
        }
      } catch (err) {
        console.error("Network or unexpected error:", err);
        navigate("/error", {
          state: {
            errorMessage: "Network error or server unreachable",
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            isAuthError: false,
          },
        });
      }
    };

    fetchExpert();
  }, [id, count]);

  // Function to get new invite count
  const fetchProjects = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    try {
      const response = await fetch(
        `${API_URL}get-all-invited-projects?expertID=${id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        Swal.fire({
          title: "Couldn't fetch intvited projects!",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      }
      const data = await response.json();
      if (data.status === "success") {
        setNewInvite(data.projectCount);
      } else {
        Swal.fire({
          title: "Couldn't fetch intvited projectsg!",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Couldn't fetch intvited projects!",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  // Function to display compact sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      const triggerHeight = 260; // adjust based on header height
      setShowStickyHeader(window.scrollY > triggerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // // API to get expert experinece data
  // const getExpertExperience = async () => {
  //   const tokenObj = localStorage.getItem("eph-token");
  //   const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
  //   const requestBody = {
  //     expertID: id,
  //   };
  //   try {
  //     let modifiedUrl = "fetch-expert-experience";
  //     const response = await fetch(`${API_URL}${modifiedUrl}`, {
  //       method: "POST",
  //       headers: {
  //         "Authorization": `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(requestBody),
  //     });

  //     const responseData = await response.json();
  //     if (responseData.status === "success") {
  //       setExperienceData(responseData.expertExperience);
  //       setHasExperince(true);
  //     } else if (responseData.status === "error") {
  //       console.error("Error fetching expert experience:", responseData.text);
  //     } else {
  //       console.error("Error fetching expert experience:", responseData.text);
  //     }
  //   } catch (error) {
  //     console.error("Network or unexpected error:", error);
  //   }
  // };

  // useEffect(() => {
  //   getExpertExperience();
  // }, [id]);

  // Api for saving profile name and link
  const saveNameData = async (name, link) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    fetch(`${API_URL}update-expert-name-data`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertID: id, name: name, link: link }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status === "success") {
          setProfileName(name);
          setLinkedinURL(link);
          Swal.fire({
            title: "Updated",
            text: "Modification has been updated successfully!",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to update bame and link!",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch(() =>
        Swal.fire({
          title: "Error",
          text: "Error while updating!",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        })
      );
  };

  //  Formating last online text
  function getLastActive(timeString) {

    if (!timeString) return 'Never logged in';
    
    const lastSeen = DateTime.fromFormat(
      timeString.replace("GMT", "").trim(),
      "EEE, dd LLL yyyy HH:mm:ss",
      { zone: "local" }
    );

    const now = DateTime.now();

    if (lastSeen.hasSame(now, "day")) {
      return `Today at ${lastSeen.toFormat("HH:mm")}`;
    } else if (lastSeen.hasSame(now.minus({ days: 1 }), "day")) {
      return `Yesterday at ${lastSeen.toFormat("HH:mm")}`;
    } else {
      return lastSeen.toFormat("EEE, dd MMM yyyy 'at' HH:mm");
    }
  };

  // Pulse function to check online status in every 60 seconds
  useEffect(() => {
    async function fetchOnlineStatus() {
      const res = await fetch(`${API_URL}fetch-expert-online-status`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ expertID: expert.id }),
      });
      const data = await res.json();

      if (data.onlineStatus) {
        setOnlineStatus({
          isOnline: data.onlineStatus.isOnline,
          lastOnline: getLastActive(data.onlineStatus.lastOnline),
        });
      } else if (expert.last_connection) {
        setOnlineStatus({
          isOnline: false,
          lastOnline: getLastActive(expert.last_connection),
        });
      } else {
        setOnlineStatus({
          isOnline: false,
          lastOnline: getLastActive(expert.last_connection),
        });
      }
    }

    if (expert?.id) {
      fetchOnlineStatus();
    };

    // run every 60 seconds
    const interval = setInterval(fetchOnlineStatus, 60000);

    return () => clearInterval(interval);
  }, [expert]);

  // Dynamic dots and highlighting
  // useEffect(() => {
  //   const handleResize = () => setWindowWidth(window.innerWidth);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // const isSmall = windowWidth < 1280;
  // const isSmaller = windowWidth < 1080;
  // const isSmallest = windowWidth < 820;
  // const spacing1 = isSmallest ? 65 : isSmaller ? 47 : isSmall ? 45 : 43;
  // const spacing2 = isSmallest ? 70 : isSmaller ? 49 : isSmall ? 47 : 45;
  // const spacing3 = isSmallest ? 75 : isSmaller ? 50 : isSmall ? 48 : 46;

  // const dotsRow1 = Math.max(Math.floor(windowWidth / spacing1), 5);
  // const dotsRow2 = Math.max(Math.floor(windowWidth / spacing2), 4);
  // const dotsRow3 = Math.max(Math.floor(windowWidth / spacing3), 3);

  // const rows = [
  //   { count: dotsRow1 },
  //   { count: dotsRow2 },
  //   { count: dotsRow3 },
  // ];

  // useEffect(() => {
  //   const randomizeHighlights = () => {
  //     const newHighlights = rows.map((row) => {
  //       const total = row.count;
  //       const highlightCount = Math.max(3, Math.floor(total * 0.1));
  //       const chosen = [];

  //       while (chosen.length < highlightCount && chosen.length < total) {
  //         const candidate = Math.floor(Math.random() * total);

  //         const tooClose = chosen.some((idx) => Math.abs(idx - candidate) < 4);
  //         if (!tooClose) {
  //           chosen.push(candidate);
  //         }
  //       }

  //       return chosen.sort((a, b) => a - b);
  //     });

  //     setRandomHighlights(newHighlights);
  //   };

  //   randomizeHighlights();
  //   const interval = setInterval(randomizeHighlights, 5000);
  //   return () => clearInterval(interval);
  // }, [windowWidth]);


  return (
    <div key={id} className="bg-gray-100 min-h-screen">
      {!data ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-white/30 rounded-xl">
          <svg
            className="animate-spin h-20 w-20 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="#365561"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="#365561"
              d="M4 12a8 8 0 018-8v8z"
            />
          </svg>
        </div>
      ) : (
        <>
          {/* Header with action buttons */}
          <AnimatePresence>
            {showMenuPanel && (
              <motion.div
                key="menu-panel"
                initial={{ y: -100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -100, opacity: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                // className="fixed top-[78px] z-50 backdrop-blur-md bg-white/70 flex flex-wrap justify-end gap-2 w-full px-4 py-2 shadow-sm"
                className="fixed top-[78px] z-50 bg-white flex flex-wrap justify-end gap-2 w-full px-4 py-2 shadow-sm"
              >
                {/* Action Buttons */}
                <div className="flex flex-wrap justify-end items-center gap-2">
                  {/* <UpdateExperience data={data} /> */}
                  <UpdateProfile data={data} />
                  <UpdateProfileExperience data={data} />
                  <ZohoButtons data={data} />
                  <AddToProject expertID={data?.id} btnName="Add to project" />
                  <MergeExpertsBtn expertName={data?.name} />
                  <DeleteExpert expertID={data?.id} />
                  {/* Separator */}
                  <div className="w-px h-6 bg-gray-300 mx-4" />
                  {/* Close Button */}
                  <button
                    onClick={() => setShowMenuPanel(false)}
                    className="text-gray-500 hover:text-black transition focus:outline-none border-none"
                  >
                    <i className="fa-solid fa-xmark text-xl"></i>
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Compact sticky menubar on scroll down */}
          <AnimatePresence>
            {showStickyHeader && (
              <motion.div
                key="sticky-header"
                className="fixed top-[78px] left-0 w-full bg-white shadow z-50 overflow-hidden hidden md:block"
                initial={{ y: -60, opacity: 1 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -60, opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{ height: "56px" }}
              >
                <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 py-2 flex justify-between items-center">
                  {/* Left: Avatar + Name */}
                  <div className="flex items-center gap-3">
                    <img
                      src={
                        data?.profilePicture?.includes(mediaLink)
                          ? data?.profilePicture
                          : `${databaseLink}${data?.profilePicture}`
                      }
                      onError={(e) => (e.target.src = expertDefaultImg)}
                      className="w-10 h-10 rounded-full object-cover border shadow-sm"
                      alt="Profile"
                    />
                    <div>
                      <div className="flex flex-wrap items-center gap-2">
                        <a
                          href={linkedinURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-md font-semibold text-gray-900 no-underline hover:no-underline"
                        >
                          {profileName}
                        </a>
                        <Verified
                          isVerified={verified}
                          setIsVerified={setVerified}
                          expert_id={data?.id}
                          callingFrom={"stickyBar"}
                        />
                        <Vip
                          isVip={data?.isVip}
                          id={data?.id}
                          callingFrom={"stickyBar"}
                        />
                      </div>
                      {experienceData?.length > 0 && (
                        <p className="text-xs text-gray-600 mt-1 mb-1">
                          {experienceData[0]?.subExperienceBlocks?.length > 0
                            ? experienceData[0]?.subExperienceBlocks[0]
                                .designation
                            : experienceData[0]?.designation}{" "}
                          @ {experienceData[0]?.companyName}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Right: Menu */}
                  <div className="hidden md:flex flex-row gap-6 items-center relative">
                    {tabs.map((tab) => (
                      <button
                        key={tab.state}
                        onClick={() => setActiveTab(tab.state)}
                        className={`relative pb-2 text-sm font-medium ${
                          activeTab === tab.state
                            ? "text-[#365561] border-b-2 border-[#365561]"
                            : "text-gray-500"
                        } transition-colors duration-300 focus:outline-none`}
                      >
                        {tab.label === "Invitations" && newInvite ? (
                          <span className="absolute -top-2 -right-[16px] sm:-top-2 sm:-right-[18px] bg-red-600 text-white text-[10px] w-4 h-4 sm:w-5 sm:h-5 rounded-full font-semibold shadow flex items-center justify-center aspect-square">
                            {newInvite}
                          </span>
                        ) : null}
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Menu bar with banner and profile picture */}
          <div className="relative bg-white shadow-sm z-40">
            {/* EPH banner with pre-designed image */}
            <div
              className="relative h-40 sm:h-40 bg-cover bg-top"
              style={{ backgroundImage: `url(${bannerBack})` }}
            >
              <div className="absolute top-4 left-4 text-white text-xl p-2 rounded-full transition-transform duration-200 ease-in-out">
                <img
                  src={logoWhite}
                  alt="EPH Logo"
                  style={{ width: "180px" }}
                />
              </div>
              <button
                onClick={() => setShowMenuPanel(true)}
                className="absolute top-4 right-4 text-white text-xl mr-2 rounded-full transition-transform duration-200 ease-in-out hover:scale-125 drop-shadow-[0_0_6px_rgba(0,0,0,0.6)] focus:outline-none border-none"
                title="Menu"
              >
                <i className="fa-solid fa-bars"></i>
              </button>
              <div className="absolute bottom-2 right-4 cursor-pointer">
                <ProfileCompletionChart
                  profileData={data}
                  hasCV={hasCV}
                  hasExperience={hasExperience}
                  hasSkill={hasSkill}
                  hasIndustry={hasIndustry}
                  hasLanguage={hasLanguage}
                />
              </div>
            </div>


            {/* EPH banner with responsive total dot count */}
            {/* <div className="relative h-40 sm:h-40 overflow-hidden bg-[#1A4247]">
              <div className="absolute inset-0 flex flex-col items-end justify-center gap-6 mr-20">
                {rows.map((row, rowIndex) => (
                  <div key={rowIndex} className="flex gap-4">
                    {Array.from({ length: row.count }).map((_, i) => {
                      const isHighlighted = randomHighlights[rowIndex]?.includes(i);
                      return (
                        <div
                          key={i}
                          className={`w-5 h-5 rounded-full transition-colors duration-700 ease-in-out ${
                            isHighlighted ? "bg-[#24D2C2]" : "bg-[#325B60]"
                          }`}
                        />
                      );
                    })}
                  </div>
                ))}
              </div>

              <div className="absolute top-4 left-4 text-white text-xl p-2 rounded-full transition-transform duration-200 ease-in-out z-10">
                <img src={logoWhite} alt="EPH Logo" style={{ width: "120px" }} />
              </div>

              <button
                onClick={() => setShowMenuPanel(true)}
                className="absolute top-4 right-4 text-white text-xl mr-2 rounded-full transition-transform duration-200 ease-in-out hover:scale-125 drop-shadow-[0_0_6px_rgba(0,0,0,0.6)] focus:outline-none border-none z-10"
                title="Menu"
              >
                <i className="fa-solid fa-bars"></i>
              </button>

              <div className="absolute bottom-2 right-4 cursor-pointer z-10">
                <ProfileCompletionChart
                  profileData={data}
                  hasCV={hasCV}
                  hasExperience={hasExperience}
                  hasSkill={hasSkill}
                  hasIndustry={hasIndustry}
                  hasLanguage={hasLanguage}
                />
              </div>
            </div> */}


            {/* Profile picture and name */}
            <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="relative flex flex-col items-left text-left -mt-20 sm:-mt-24">
                {/* Top part of the menu bar */}
                <div className="mt-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  {/* Left: Profile Picture */}
                  <div className="relative w-32 h-32 sm:w-36 sm:h-36 mt-3">
                    <ProfilePicture 
                      expertDefaultImg={expertDefaultImg}
                      profilePicturePreview={profilePicturePreview}
                      setProfilePicturePreview={setProfilePicturePreview}
                      expertID={id}
                    />
                    <div
                      className={`absolute top-9 -right-5 w-4 h-4 sm:w-5 sm:h-5 sm:top-12 sm:-right-6 rounded-full border-2 ${
                        onlineStatus?.isOnline === true
                          ? "bg-green-500 border-white"
                          : "bg-yellow-400 border-white"
                      }`}
                    >
                      <span className="text-gray-300 text-xs sm:text-sm font-medium px-2 py-0.5 rounded whitespace-nowrap absolute -top-1 left-2 sm:left-4">
                        {onlineStatus?.isOnline ? 'Online' : onlineStatus.lastOnline}
                      </span>
                    </div>
                  </div>
                  {/* Right: Company Logo */}
                  {experienceData?.length > 0 && (
                    <div className="flex flex-row gap-2 items-center sm:mt-20 sm:gap-3">
                      {experienceData[0]?.companyLogo ? (
                        <img
                          src={
                            experienceData[0]?.companyLogo.includes(
                              "/pictures/"
                            )
                              ? `https://images.expertpowerhouse.com${experienceData[0]?.companyLogo}`
                              : experienceData[0]?.companyLogo
                          }
                          alt="Company Logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = industryLogo;
                          }}
                          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-contain border"
                        />
                      ) : (
                        <img
                          src={industryLogo}
                          alt="Default Industry Logo"
                          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-contain border bg-gray-100"
                        />
                      )}
                      <p className="text-m text-gray-600 font-semibold">
                        {experienceData[0]?.companyName}
                      </p>
                    </div>
                  )}
                </div>

                {/* bottom part of menu bar */}
                <div className="mt-2 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  {/* Left: Name + Role*/}
                  <AnimatePresence mode="wait">
                    {isNameEditing ? (
                      <motion.div
                        key="edit-fields"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.3 }}
                        className="flex flex-col gap-1 w-1/2 p-[3px] rounded-md"
                      >
                        {/* Top right icons */}
                        <div className="relative top-1 h-[0px] flex justify-end gap-3">
                          <button
                            className="text-gray-500 hover:text-[#365561] transition focus:outline-none"
                            onClick={() => {
                              saveNameData(editedName, editedLinkedinURL);
                              setIsNameEditing(false);
                            }}
                            title="Save"
                          >
                            <i className="fa-solid fa-floppy-disk text-lg" />
                          </button>
                          <button
                            className="text-gray-500 hover:text-red-600 transition focus:outline-none"
                            onClick={() => setIsNameEditing(false)}
                            title="Cancel"
                          >
                            <i className="fa-solid fa-xmark text-lg" />
                          </button>
                        </div>

                        {/* Name Input */}
                        <input
                          type="text"
                          value={editedName}
                          onChange={(e) => setEditedName(e.target.value)}
                          placeholder="Full name"
                          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none w-full text-sm sm:text-base"
                        />

                        {/* LinkedIn Input */}
                        <input
                          type="text"
                          value={editedLinkedinURL}
                          onChange={(e) => setEditedLinkedinURL(e.target.value)}
                          placeholder="LinkedIn URL"
                          className="border-b border-gray-300 text-blue-500 hover:border-[#365561] focus:border-[#365561] focus:outline-none w-full text-sm sm:text-base"
                        />
                      </motion.div>
                    ) : (
                      <motion.div
                        key="name-heading"
                        initial={{ opacity: 0, y: -5 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -5 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="flex flex-col">
                          <div className="flex flex-wrap items-center gap-2">
                            <a
                              href={linkedinURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-2xl sm:text-3xl font-bold text-gray-900 no-underline hover:no-underline relative group"
                              onMouseEnter={() => {
                                const timer = setTimeout(
                                  () => setShowNameTooltip(true),
                                  2000
                                );
                                setNameTooltipTimer(timer);
                              }}
                              onMouseLeave={() => {
                                clearTimeout(nameTooltipTimer);
                                setShowNameTooltip(false);
                              }}
                            >
                              {profileName}

                              {/* Tooltip */}
                              <AnimatePresence>
                                {showNameTooltip && (
                                  <motion.div
                                    initial={{ opacity: 0, y: -5 }}
                                    animate={{ opacity: 1, y: -10 }}
                                    exit={{ opacity: 0, y: -5 }}
                                    transition={{ duration: 0.3 }}
                                    className="absolute bottom-full left-1/2 -translate-x-1/2 mt-3 z-50"
                                  >
                                    <div className="relative opacity-80 font-normal bg-black text-white text-sm px-1 py-2 w-[100px] rounded-tr-[10px] rounded-tl-[10px] rounded-br-[10px] shadow-md whitespace-nowrap text-wrap text-center">
                                      Click to view LinkedIn profile
                                      <svg
                                        className="absolute top-[60px] -left-6 w-12 h-8"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g transform="translate(0, 220) scale(1, -1)">
                                          <path
                                            d="
                                            M 100,10
                                            Q 100,100 200,120
                                            L 100,120
                                            Q 100,100 100,10
                                          "
                                            fill="black"
                                            stroke="black"
                                            strokeWidth="0"
                                            // opacity={0.7}
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </a>
                            <Verified
                              isVerified={verified}
                              setIsVerified={setVerified}
                              expert_id={data?.id}
                            />
                            <Vip isVip={data?.isVip} id={data?.id} />
                            <CV expertData={data} setHasCV={setHasCV} />
                            <button
                              className="relative text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none mt-0.5 px-1.5 py-0.3 rounded-full border transition"
                              onMouseEnter={() => setEditNameTooltip(true)}
                              onMouseLeave={() => setEditNameTooltip(false)}
                              onClick={() => {
                                setIsNameEditing(true);
                                setEditedName(profileName);
                                setEditedLinkedinURL(linkedinURL);
                                setEditNameTooltip(false);
                              }}
                            >
                              <i
                                className="fa-solid fa-pencil"
                                style={{ fontSize: "13px" }}
                              />
                              <AnimatePresence>
                                {editNameTooltip && (
                                  <motion.div
                                    className="absolute -top-7 -left-14 -translate-x-1/2 bg-[#365561] text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap z-50 pointer-events-none"
                                    initial={{ opacity: 0, y: -20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: 20 }}
                                    transition={{ duration: 0.3 }}
                                  >
                                    <span>Edit name and LinkedIn URL</span>
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </button>
                          </div>
                          {experienceData?.length > 0 && (
                            <p className="text-sm text-gray-600 mt-1 mb-1">
                              {experienceData[0]?.subExperienceBlocks?.length >
                              0
                                ? experienceData[0]?.subExperienceBlocks[0]
                                    .designation
                                : experienceData[0]?.designation}{" "}
                              @ {experienceData[0]?.companyName}
                            </p>
                          )}
                          <div>
                            <ExpertAverageRating expertId={data?.id} />
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                  {/* Right: Action buttons or menu bar */}
                  <div className="relative flex gap-6">
                    {tabs.map((tab) => (
                      <div key={tab.state} className="relative group">
                        <button
                          onClick={() => setActiveTab(tab.state)}
                          className={`relative pb-2 text-sm font-medium ${
                            activeTab === tab.state
                              ? "text-[#365561]"
                              : "text-gray-500"
                          } transition-colors duration-300 focus:outline-none`}
                        >
                          {/* Notification Badge */}
                          {tab.label === "Invitations" && newInvite ? (
                            <span className="absolute -top-2 -right-[16px] sm:-top-2 sm:-right-[18px] bg-red-600 text-white text-[12px] w-4 h-4 sm:w-5 sm:h-5 rounded-full font-semibold shadow flex items-center justify-center aspect-square">
                              {newInvite}
                            </span>
                          ) : null}

                          {/* Label */}
                          {tab.label}
                          {activeTab === tab.state && (
                            <motion.div
                              layoutId="underline"
                              className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#365561]"
                              transition={{
                                type: "spring",
                                stiffness: 500,
                                damping: 30,
                              }}
                            />
                          )}
                        </button>

                        {/* Tooltip */}
                        <div className="absolute bottom-12 left-14 -translate-x-1/2 bg-black text-white text-xs rounded opacity-0 group-hover:opacity-80 transition-opacity duration-400 pointer-events-none whitespace-nowrap z-10">
                          {tab.label === "My Profile" && (
                            <div className="relative font-normal bg-black text-white text-sm px-1 py-2 w-[100px] rounded-tr-[10px] rounded-tl-[10px] rounded-br-[10px] shadow-md whitespace-nowrap text-wrap text-center">
                              Click to view or modify your profile
                              <svg
                                className="absolute top-[60px] -left-6 w-12 h-8"
                                viewBox="0 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g transform="translate(0, 220) scale(1, -1)">
                                  <path
                                    d="
                                    M 100,10
                                    Q 100,100 200,120
                                    L 100,120
                                    Q 100,100 100,10
                                  "
                                    fill="black"
                                    stroke="black"
                                    strokeWidth="0"
                                  />
                                </g>
                              </svg>
                            </div>
                          )}
                          {tab.label === "My Projects" && (
                            <div className="relative font-normal bg-black text-white text-sm px-1 py-2 w-[100px] rounded-tr-[10px] rounded-tl-[10px] rounded-br-[10px] shadow-md whitespace-nowrap text-wrap text-center">
                              Click to view projects you are involved
                              <svg
                                className="absolute top-[60px] -left-6 w-12 h-8"
                                viewBox="0 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g transform="translate(0, 220) scale(1, -1)">
                                  <path
                                    d="
                                    M 100,10
                                    Q 100,100 200,120
                                    L 100,120
                                    Q 100,100 100,10
                                  "
                                    fill="black"
                                    stroke="black"
                                    strokeWidth="0"
                                  />
                                </g>
                              </svg>
                            </div>
                          )}
                          {tab.label === "Invitations" && (
                            <div className="relative font-normal bg-black text-white text-sm px-1 py-2 w-[100px] rounded-tr-[10px] rounded-tl-[10px] rounded-br-[10px] shadow-md whitespace-nowrap text-wrap text-center">
                              Click to review project invitations
                              <svg
                                className="absolute top-[60px] -left-6 w-12 h-8"
                                viewBox="0 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g transform="translate(0, 220) scale(1, -1)">
                                  <path
                                    d="
                                    M 100,10
                                    Q 100,100 200,120
                                    L 100,120
                                    Q 100,100 100,10
                                  "
                                    fill="black"
                                    stroke="black"
                                    strokeWidth="0"
                                  />
                                </g>
                              </svg>
                            </div>
                          )}
                          {tab.label === "Projects" && (
                            <div className="relative font-normal bg-black text-white text-sm -ml-[105px] px-1 py-2 w-[100px] rounded-tr-[5px] rounded-tl-[5px] rounded-bl-[5px] shadow-md whitespace-nowrap text-wrap text-center">
                              Click to see available projects
                              <svg
                                className="absolute top-[60px] left-[75px] w-12 h-8"
                                viewBox="0 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g transform="translate(206, 220) scale(-1, -1)">
                                  <path
                                    d="
                                    M 100,10
                                    Q 100,100 200,120
                                    L 100,120
                                    Q 100,100 100,10
                                  "
                                    fill="black"
                                    stroke="black"
                                    strokeWidth="0"
                                  />
                                </g>
                              </svg>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main content area */}
          <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 pt-4 sm:pt-36 pb-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
            {activeTab === "profile" && (
              <ProfilePage
                data={data}
                expertID={id}
                experienceData={experienceData}
                setExperienceData={setExperienceData}
                setHasExperince={setHasExperince}
                setHasSkill={setHasSkill}
                setHasIndustry={setHasIndustry}
                setHasLanguage={setHasLanguage}
                showStickyHeader={showStickyHeader}
              />
            )}
            {activeTab === "projects" && (
              <ProjectsPage expertID={id} showStickyHeader={showStickyHeader} />
            )}
            {activeTab === "invitation" && (
              <InvitationsPage
                expertID={id}
                getCount={fetchProjects}
                showStickyHeader={showStickyHeader}
              />
            )}
            {activeTab === "myProjects" && (
              <MyProjectPage
                expertID={id}
                showStickyHeader={showStickyHeader}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}
